import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import MaterialGrid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core';

const Grid = forwardRef(({ flex, className, ...props }, ref) => {
    const attrs = { ref };
    const addl = { flex };
    const additional = Object.keys(addl)
        .filter(key => Boolean(addl[key]))
        .map(key => ({ [key]: addl[key] }));

    attrs.className = [className];

    // memoize this.
    if (additional.length) {
        const classes = makeStyles({
            row: Object.assign(...additional)
        })();

        attrs.className.push(classes.row);
    }

    attrs.className = attrs.className.filter(Boolean).join(' ');

    return <MaterialGrid {...attrs} {...props} />;
});

Grid.displayName = 'NeptuneGrid';
Grid.propTypes = {
    ...MaterialGrid.propTypes,
    flex: PropTypes.string
};

Grid.defaultProps = {
    ...MaterialGrid.defaultProps,
    flex: null
};

export default Grid;
